import axios from "axios";

export const doTempUpload = async (url, file) => {
  try {
    const requestFileUpload = axios.create({
      headers: {
        "Content-Type": file?.type || "application/octet-stream",
      },
    });
    const result = await requestFileUpload.put(url, file);

    return result?.status;
  } catch (error) {
    console.error("Error !");
  }

  return undefined;
};

export const doUploadFiles = async (
  files,
  getFileUploadUrl,
  { isComment, boardCode }
) => {
  const tempFiles = [];
  if (files.length) {
    for await (const o of files) {
      if (o.fileId.includes("temp-fileId-")) {
        const fileUploadUrlData = await getFileUploadUrl(boardCode, isComment);
        const resStatus = await doTempUpload(fileUploadUrlData.url, o.file);
        if (resStatus === 200) {
          const fileUploadInfo = {
            fileId: fileUploadUrlData?.fileId,
            name: o.name,
            file: o.file,
          };
          tempFiles.push(fileUploadInfo);
        }
      } else {
        tempFiles.push(o);
      }
    }
  }
  return tempFiles;
};

export const doUploadSingleFile = async (
  file,
  getFileUploadUrl,
  { isComment, boardCode }
) => {
  if (file.fileId.includes("temp-fileId-")) {
    const fileUploadUrlData = await getFileUploadUrl(boardCode, isComment);
    const resStatus = await doTempUpload(fileUploadUrlData.url, file.file);
    if (resStatus === 200) {
      const fileUploadInfo = {
        fileId: fileUploadUrlData?.fileId,
        name: file.name,
        file: file.file,
      };
      return fileUploadInfo;
    }
  }
  return file;
};
